import { useEffect, useState } from 'react';
import * as $ from 'jquery';
import { useNavigate } from 'react-router-dom';
import AutoLogout from '../autologout';
import { baseurladdress } from "../baseurl";

function Topnavbar() {

    AutoLogout();
    const navigate = useNavigate();
    const [staffName, setStaffName] = useState('');

    const logoutUser = (e) => {
        e.preventDefault();
        console.log('Logging out...');
        localStorage.removeItem("selectedMenu");
        localStorage.removeItem("selectedMenu");

        localStorage.removeItem('token');
        localStorage.removeItem('userID');
        localStorage.removeItem('username');
        localStorage.removeItem('sync');
        localStorage.removeItem('staffid');

        navigate('/');
    };

    // useEffect(() => {
    //     const name = localStorage.getItem('username');
    //     if (name) {
    //         setStaffName(name);
    //     }
    // }, []);

    useEffect(() => {
        const name = localStorage.getItem('username');
        if (name) {
            const capitalizedName = name.charAt(0).toUpperCase() + name.slice(1);
            setStaffName(capitalizedName);
        }
    }, []);

    return (
        <div className="header">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="nav-control float-left">
                            <div className="hamburger">
                                <span className="line" />
                                <span className="line" />
                                <span className="line" />
                            </div>
                        </div>

                        <div className="float-right">
                            <ul className="nav align-items-center">
                                <li className="nav-item mr-3">
                                    <span style={{ fontWeight: 'bold', color: '#333' }}>
                                        🧑‍🤝‍🧑 Welcome, {staffName}
                                    </span>
                                </li>
                                <li className="nav-item">
                                    <a href="#" onClick={logoutUser} className="nav-link">
                                        <i className="ti-power-off" style={{ fontWeight: "bold", color: "red" }} />{' '}
                                        <span style={{ fontWeight: "bold", color: "black" }}>Logout</span>
                                    </a>
                                </li>
                            </ul>

                        </div>

                    </div>
                </div>
            </div>

        </div>

    );
}

export default Topnavbar;